import { capitalize } from 'lodash';
import { Maybe } from '@atlassian/cssxp-typescommon';

export const formatTermPaymentName = (paymentMethod: Maybe<string> | undefined) => {
  const index = paymentMethod?.search(/\d/);

  if (index === -1) {
    return paymentMethod && capitalize(paymentMethod);
  }

  const before = paymentMethod?.slice(0, index);
  const after = paymentMethod?.slice(index);

  return `${capitalize(before)}-${after}`;
};
